// @generated by protoc-gen-es v2.14.1 with parameter "target=ts"
// @generated from file travplaces/v1/category.proto (package travplaces.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_travplaces_v1_audit } from "./audit_pb";
import { file_travplaces_v1_authz } from "./authz_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file travplaces/v1/category.proto.
 */
export const file_travplaces_v1_category: GenFile = /*@__PURE__*/
  fileDesc("Chx0cmF2cGxhY2VzL3YxL2NhdGVnb3J5LnByb3RvEg10cmF2cGxhY2VzLnYxItkBCghDYXRlZ29yeRIKCgJpZBgBIAEoCRILCgNrZXkYAiABKAkSDQoFbGFiZWwYAyABKAkSFgoOY2F0ZWdvcnlfZ3JvdXAYBCABKAkSDAoEaWNvbhgFIAEoCRIdChVkZWZhdWx0X2R3ZWxsX21pbnV0ZXMYBiABKAUSIAoYaXNfc2FmZXR5X2luZnJhc3RydWN0dXJlGAcgASgIEhQKDGlzX2F2b2lkYWJsZRgIIAEoCBIUCgxpc192aXNpdGFibGUYCSABKAgSEgoKc29ydF9vcmRlchgKIAEoBSIXChVMaXN0Q2F0ZWdvcmllc1JlcXVlc3QiRQoWTGlzdENhdGVnb3JpZXNSZXNwb25zZRIrCgpjYXRlZ29yaWVzGAEgAygLMhcudHJhdnBsYWNlcy52MS5DYXRlZ29yeTJ9Cg9DYXRlZ29yeVNlcnZpY2USagoOTGlzdENhdGVnb3JpZXMSJC50cmF2cGxhY2VzLnYxLkxpc3RDYXRlZ29yaWVzUmVxdWVzdBolLnRyYXZwbGFjZXMudjEuTGlzdENhdGVnb3JpZXNSZXNwb25zZSILiuowAwoBCpDqMAFCqAEKEWNvbS50cmF2cGxhY2VzLnYxQg1DYXRlZ29yeVByb3RvUAFaL3RyYXZwbGFjZXMvZ2VuL3Byb3RvL3RyYXZwbGFjZXMvdjE7dHJhdnBsYWNlc3YxogIDVFhYqgINVHJhdnBsYWNlcy5WMcoCDVRyYXZwbGFjZXNcVjHiAhlUcmF2cGxhY2VzXFYxXEdQQk1ldGFkYXRh6gIOVHJhdnBsYWNlczo6VjFiBnByb3RvMw", [file_travplaces_v1_audit, file_travplaces_v1_authz]);

/**
 * Category classifies a POI (attraction, food, safety, …). Drives dwell time,
 * avoidability, and whether a POI can be an itinerary stop.
 *
 * @generated from message travplaces.v1.Category
 */
export type Category = Message<"travplaces.v1.Category"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string key = 2;
   */
  key: string;

  /**
   * @generated from field: string label = 3;
   */
  label: string;

  /**
   * @generated from field: string category_group = 4;
   */
  categoryGroup: string;

  /**
   * @generated from field: string icon = 5;
   */
  icon: string;

  /**
   * @generated from field: int32 default_dwell_minutes = 6;
   */
  defaultDwellMinutes: number;

  /**
   * @generated from field: bool is_safety_infrastructure = 7;
   */
  isSafetyInfrastructure: boolean;

  /**
   * @generated from field: bool is_avoidable = 8;
   */
  isAvoidable: boolean;

  /**
   * @generated from field: bool is_visitable = 9;
   */
  isVisitable: boolean;

  /**
   * @generated from field: int32 sort_order = 10;
   */
  sortOrder: number;
};

/**
 * Describes the message travplaces.v1.Category.
 * Use `create(CategorySchema)` to create a new message.
 */
export const CategorySchema: GenMessage<Category> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_category, 0);

/**
 * @generated from message travplaces.v1.ListCategoriesRequest
 */
export type ListCategoriesRequest = Message<"travplaces.v1.ListCategoriesRequest"> & {
};

/**
 * Describes the message travplaces.v1.ListCategoriesRequest.
 * Use `create(ListCategoriesRequestSchema)` to create a new message.
 */
export const ListCategoriesRequestSchema: GenMessage<ListCategoriesRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_category, 1);

/**
 * @generated from message travplaces.v1.ListCategoriesResponse
 */
export type ListCategoriesResponse = Message<"travplaces.v1.ListCategoriesResponse"> & {
  /**
   * @generated from field: repeated travplaces.v1.Category categories = 1;
   */
  categories: Category[];
};

/**
 * Describes the message travplaces.v1.ListCategoriesResponse.
 * Use `create(ListCategoriesResponseSchema)` to create a new message.
 */
export const ListCategoriesResponseSchema: GenMessage<ListCategoriesResponse> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_category, 2);

/**
 * CategoryService exposes the (seeded, admin-editable) category catalogue.
 *
 * @generated from service travplaces.v1.CategoryService
 */
export const CategoryService: GenService<{
  /**
   * ListCategories returns all categories in display order.
   *
   * @generated from rpc travplaces.v1.CategoryService.ListCategories
   */
  listCategories: {
    methodKind: "unary";
    input: typeof ListCategoriesRequestSchema;
    output: typeof ListCategoriesResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_travplaces_v1_category, 0);

